module.exports = __webpack_public_path__ + "img/a5be4da.svg";